<template>
  <div>
    <Loader v-if="loading"/>

    <div id="app" v-if="isAuth">
      <Header v-on:set-page="setPage" :page="page"/>

      <Flash v-if="error" :message="error" type="danger" v-on:close="error = ''"/>

      <div class="container-fluid">
        <Test v-if="page === 'test'"/>
        <Client v-else/>
      </div>
    </div>

    <Login v-else-if="!loading"/>
  </div>
</template>

<script>
import Header from './components/Header';
import Login from './components/Login';
import Client from './components/Client';
import Test from './components/Test';
import Loader from './components/common/Loader';
import Flash from './components/common/Flash';

export default {
  name: 'App',
  components: {Header, Login, Client, Test, Loader, Flash},

  data() {
    return {
      page: 'client',
      loading: true,
      error: '',
    };
  },

  created() {
    this.loadData();
  },

  methods: {
    setPage(page) {
      this.page = page;
    },

    async loadData() {
      if (!this.isAuth && this.$store.getters.hasToken) {
        this.loading = true;

        try {
          await this.$store.dispatch('AUTH');
        } catch (e) {
          this.error = e.message;
        }
      }

      this.loading = false;
    },
  },

  computed: {
    isAuth: function () {
      return this.$store.getters.isAuthorized;
    },
  },
};
</script>
